import { ActionState, EventType } from '..';
import { IEvent } from '@studyportals/event-aggregation-service-interface';

export class AuthenticationActionStateChangeEvent implements IEvent {
	public static EventType: string = EventType.AUTHENTICATION_ACTION_STATE_CHANGE_EVENT;

	public readonly timestamp: Date;
	public readonly eventType = AuthenticationActionStateChangeEvent.EventType;

	constructor(public actionState: ActionState) {
		this.timestamp = new Date();
	}
}
